<script lang="ts">
    import sanityImage from "../../sanity/sanityImage";

    export let stars
    export let className : string = ''
</script>

<div class="review-card__stars">
    {#each stars as star}
        <img src={sanityImage(star.asset._ref)} alt="star icon" class="{className}"/> 
    {/each}
</div>


<style lang="postcss">
    .review-card__stars {
        display:flex;
        gap:8px;

        & img {
            height:25px;
        }
    }
</style>